import styled from 'styled-components';
import {
  LG_COLOR,
  GRAPHITE_COLOR,
  PLATINUM_COLOR,
  ICE_COLOR,
  MAIN_BLUE_COLOR,
} from 'containers/App/constants';

export const AdminCenterStyles = styled.div`
  min-height: calc(100vh - 56px);
  background: ${ICE_COLOR};

  .admin-center-content {
    height: calc(100vh - 56px);
    min-width: 0;
    overflow: auto;
  }
`;

export const AdminLoginPageStyles = styled.div`
  .admin-login-container {
    min-height: calc(100vh - 72px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    background:
      linear-gradient(135deg, rgba(165, 1, 53, 0.08), rgba(22, 81, 119, 0.08)),
      #f8f9fb;
  }

  .admin-login-panel {
    background: #fff;
    border: 1px solid ${PLATINUM_COLOR};
    border-radius: 8px;
    box-shadow: 0 16px 40px rgba(65, 70, 80, 0.14);
    display: grid;
    grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.95fr);
    max-width: 980px;
    min-height: 420px;
    overflow: hidden;
    width: min(980px, calc(100vw - 32px));
  }

  .admin-login-intro {
    background:
      linear-gradient(145deg, rgba(165, 1, 53, 0.94), rgba(22, 81, 119, 0.92)),
      ${MAIN_BLUE_COLOR};
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 40px;
  }

  .admin-login-form-section {
    padding: 40px;
  }

  .admin-login-eyebrow {
    color: rgba(255, 255, 255, 0.78);
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  .admin-login-intro h1 {
    color: #fff;
    font-size: 2.25rem;
    font-weight: 600;
    line-height: 1.15;
    margin-bottom: 12px;
  }

  .admin-login-intro p {
    color: rgba(255, 255, 255, 0.86);
    font-size: 1rem;
    line-height: 1.6;
    margin: 0;
    max-width: 360px;
  }

  .admin-login-session-note {
    border-top: 1px solid rgba(255, 255, 255, 0.28);
    color: rgba(255, 255, 255, 0.84);
    font-size: 0.9rem;
    padding-top: 18px;
  }

  .admin-login-form-section h2 {
    color: ${GRAPHITE_COLOR};
    font-size: 1.45rem;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .admin-login-form-section label {
    color: ${GRAPHITE_COLOR};
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 6px;
  }

  .admin-login-form {
    display: flex;
    flex-direction: column;
  }

  .admin-login-field {
    margin: 0;
  }

  .admin-login-field-spacer {
    flex: 0 0 28px;
    height: 28px;
  }

  .admin-login-field-password {
    margin: 0;
  }

  .admin-login-actions {
    display: flex;
    justify-content: center;
    padding-top: 72px;
  }

  .admin-login-form-section .form-control {
    border-color: #d9dde3;
    min-height: 44px;
  }

  .admin-login-form-section .form-control:focus {
    border-color: ${MAIN_BLUE_COLOR};
    box-shadow: 0 0 0 0.18rem rgba(22, 81, 119, 0.16);
  }

  .admin-login-submit {
    align-items: center;
    display: inline-flex;
    gap: 8px;
    justify-content: center;
    min-height: 44px;
    min-width: 136px;
    padding-inline: 22px;
  }

  .admin-login-submit {
    margin-top: 0;
  }

  .admin-login-submit.btn-primary {
    background-color: ${LG_COLOR};
    border-color: ${LG_COLOR};
  }

  .admin-login-submit.btn-primary:hover,
  .admin-login-submit.btn-primary:focus {
    background-color: #8d012d;
    border-color: #8d012d;
  }

  @media (max-width: 860px) {
    .admin-login-panel {
      grid-template-columns: 1fr;
      min-height: 0;
    }

    .admin-login-intro,
    .admin-login-form-section {
      padding: 28px;
    }

    .admin-login-intro {
      gap: 28px;
    }
  }
`;
